import { Component, OnInit } from '@angular/core';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { Subscription } from 'rxjs';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { TalentInsightsService } from 'src/app/_services/talent-insights.service';

@Component({
  selector: 'app-report-profiles',
  templateUrl: './report-profiles.component.html',
  styleUrls: ['./report-profiles.component.scss']
})
export class ReportProfilesComponent implements OnInit {

  seniorityData: any = [];
  talentfilterdata: any = {};
  profileData: any = [];
  profileDataAll: any[] = [];

  currentPage: number = 1;
  pageSize: number = 9;
  start: number = 0;
  end: number = 9;
  totalCount: number = 0;
  totalResultsCount: number = 0;
  profileCount = 50;
  apiCalledSeniority: boolean = false;
  apiCalledProfile: boolean = false;
  
  continentselected: string;
  subscriptions: Array<Subscription> = [];

  // Data/Properties for Years Of Experience - Overall or Total and Average
  isCandidateInRange: boolean = false;
  yearsofexperience: any = [];
  experienceType: string = 'totalyearsofexperience';
  dataSourceYearsOfExperience: any = [];
  selectedExperience: any = 'Overall';
  apiCalledExperience: boolean = false;

  // Data/Properties for Years Of Experience - Current
  isCandidateInRangeCurrent: boolean = false;
  apiCalledExperienceCurrent: boolean = false;
  dataSourceYearsOfExperienceCurrent: any = [];
  profilesubscription: Subscription;
  yearsofexpdata: any = [];
  profiledataai: any;
  senioritydata: any = [];
  totalresultcount: any;

  insightsExportSubscription: Subscription = null;

  constructor(private personSearchService: PersonSearchService, private localstorageservice: LocalStorageService,
    private filterDataHandlerService: FilterDataHandlerService,
    private talentInsightsReqHandlerService: TalentInsightsReqHandlerService,
    private aggReqObjectHandlerService: AggReqObjectHandlerService,
    private aggService: AggregationService, private talentInsightsService: TalentInsightsService) { }

  ngOnInit(): void {
    this.continentselected = this.localstorageservice.getItem('talentRegion');

    // const profilesubscription = this.personSearchService.gettalentinsights.subscribe((response) => this.setUpdatedData());
    // this.subscriptions.push(profilesubscription);

    this.setYOEType(this.filterDataHandlerService.yoeType);
    this.setUpdatedData(null);
    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => {
      this.setUpdatedData();
      // When we clear filter we want to reset the yoeType to Total
      _methodDetails.methodName === 'clearFilters' && this.handleYOEUpdateEvent({
        yoeType: GeneralConstants.YOE_TYPE.TOTAL,
        emmitedFrom: GeneralConstants.COMPONENT_NAME.PERSON_SEARCH_FILTER
      });
    });
    this.subscriptions.push(filterMethodEvent);

    const yoeTypeUpdateEvent = this.filterDataHandlerService.yearsOfExperienceTypeEvent.subscribe(typeData => this.handleYOEUpdateEvent(typeData));
    this.subscriptions.push(yoeTypeUpdateEvent);

    // subscribe to insights-export subject for processing request from parent
    this.insightsExportSubscription = this.talentInsightsService.insightsExportRequestEvent.subscribe((requestData: { type?: string, action?: string, data?: { currentTab?: string } }) => {
      if(requestData && requestData.type === 'SIGNAL') {
        this.shareDataForInsightsExport(requestData);
      }
    });
    this.subscriptions.push(this.insightsExportSubscription);
  }

  private setUpdatedData(talentFilterData?: any) {
    if (talentFilterData) { 
      this.talentfilterdata = talentFilterData 
    }
    this.start = 0;
    this.end = 9;
    this.currentPage = 1;
    this.getSeniority();
    this.getYearsOfExperience();
    this.getYearsOfExperienceCurrent();
    this.getProfile();
    this.personSearchService.setTalentinsightsFilterAI(this.filterDataHandlerService.fetchFilterData)

  }

  getLocation(dataArr: any[]){
    this.profileData = dataArr.map(data => {
      let currentLocation = data.location_name ? data.location_name : data.location_names && data.location_names.length ? data.location_names[0] : 
        data.location_region && data.location_locality && data.location_country ? 
        `${data.location_region}  ${data.location_locality}  ${data.location_country}` : 
        data.location_region && data.location_country ? `${data.location_region}  ${data.location_country}` :
        data.location_locality && data.location_country ? `${data.location_locality}  ${data.location_country}` :
        data.location_region ? `${data.location_region}` :
        data.location_locality ? `${data.location_locality}` : data.location_country ? `${data.location_country}` : '';

      data.currentLocation = currentLocation;

      return data;
    });
  }

  getSeniority() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "seniority";
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personSearchService.getTotalAggs(aggReq).subscribe((response) => {
      this.apiCalledSeniority = true;
      const tempData = response.data.aggregations.seniority;
      this.seniorityData = response.data.aggregations.seniority.slice(0, 5);
      this.totalresultcount = response.data.totalresultscount;
      this.getprofiledataai(tempData, 'seniority')

      const CharForSeniority = [];

      this.seniorityData && this.seniorityData.forEach(x => {
        let dataObj = {
          label: this.convertToTitleCase(x.key),
          value: x.doc_count,
          tooltext: `$label <br> Talent Count: $dataValue`
        }
        CharForSeniority.push(dataObj)
      })

      this.seniorityData = {
        type: "doughnut2d",
        dataFormat: "json",
        chart: {
          paletteColors: "#eacc39, #86db94, #8585dd, #aaaaaa, #95e1d3, #1B4E6B, #3934a5, #1B4E6B",
          use3DLighting: "0",
          decimals: "0",
          yAxisNameFontColor: "#2C2C2C",
          animateClockwise: "1",
          legendPosition: "bottom",
          enableSmartLabels: "1",
          manageLabelOverflow: "1",
          useEllipsesWhenOverflow: "1",
          legendAllowDrag: "0",
          theme: "fusion",
          legendWidth: "300",
          showLabels: "0",
          showPercentValues: "0",
          showValues: "0",
          formatNumberScale: "0",
          thousandSeparatorPosition: "2,3",
          labelFont: "Poppins",
          legendItemFont: "Poppins",
        },
        data: CharForSeniority,
      };
    });
  }

  convertToTitleCase(stringName){
    stringName = stringName.toLowerCase().split(' ');
    for(let i = 0;i<stringName.length;i++){
      stringName[i] = stringName[i].charAt(0).toUpperCase() + stringName[i].slice(1);
    }
    return stringName.join(' ');
  }

  getYearsOfExperience(){
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = this.experienceType;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personSearchService.getTotalAggs(aggReq).subscribe((response) => {
      this.apiCalledExperience = true;
      const tempData = response.data.aggregations[`${this.experienceType}`];
      this.yearsofexperience = tempData;
      this.getprofiledataai(this.yearsofexperience, 'yearsofexp')
      const CharForYearsOfExperience = [];
    
      const tempArr = []
      this.yearsofexperience && this.yearsofexperience.forEach(x => {
        let dataObj = {
          label: `${x.key.split(' ')[0]}`,
          value: x.doc_count,
          tooltext: `Years: $label <br> Talent Count: $dataValue`
        }
        tempArr.push(dataObj.value);
        CharForYearsOfExperience.push(dataObj);
      })

      this.isCandidateInRange = !tempArr.every(value => value===0);

      this.dataSourceYearsOfExperience = this.getGenericDataSourceYOE();
      this.dataSourceYearsOfExperience.data = CharForYearsOfExperience;
    });
  }

  getYearsOfExperienceCurrent(){
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "currentyearsofexperience";
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personSearchService.getTotalAggs(aggReq).subscribe((response) => {
      this.apiCalledExperienceCurrent = true;
      const yearsOfExperienceCurrent = response.data?.aggregations?.currentyearsofexperience;

      const CharForYearsOfExperience = [];
      const tempArr = [];
      yearsOfExperienceCurrent?.forEach(x => {
        let dataObj = {
          label: `${x.key.split(' ')[0]}`,
          value: x.doc_count,
          tooltext: `Years: $label <br> Talent Count: $dataValue`
        }
        tempArr.push(dataObj.value);
        CharForYearsOfExperience.push(dataObj);
      });
      this.isCandidateInRangeCurrent = !tempArr.every(value => value===0);
      
      this.dataSourceYearsOfExperienceCurrent = this.getGenericDataSourceYOE();
      this.dataSourceYearsOfExperienceCurrent.data = CharForYearsOfExperience;
    });
  }

  getExperienceType(event){
    this.experienceType = event.target.value;
    if(this.experienceType === 'totalyearsofexperience'){
      this.selectedExperience = 'Overall';
    }else if( this.experienceType === 'currentyearsofexperience'){
      this.selectedExperience = 'Current';
    }else{
      this.selectedExperience = 'Average';
    }
    this.filterDataHandlerService.emitYearsOfExperienceType({ 
      yoeType: this.selectedExperience === 'Average' ? GeneralConstants.YOE_TYPE.AVG : GeneralConstants.YOE_TYPE.TOTAL, 
      emmitedFrom: GeneralConstants.COMPONENT_NAME.REPORT_PROFILES
    });
    this.getYearsOfExperience();
  }

  getProfile(){
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.currentcompaniesonly = false;
    aggReq.fullnames = [];
    aggReq.iscurrent = false;
    aggReq.pastcompaniesonly = false;
    aggReq.resultsize = 50;
    aggReq.startindex = 0;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personSearchService.getPersonSearchRecommendCandidates(aggReq).subscribe((response)=>{
      this.apiCalledProfile = true;
          const tempData = response.data.results;
          this.profileDataAll = response.data.results;
          this.totalResultsCount = response.data.totalresultcount;
          this.totalCount = tempData.length;
          this.profileData = tempData.slice(this.start, this.end);
          this.getLocation(this.profileData);
    })

  }

  openUrl(link, type) {
    if (link.startsWith("www.linkedin") || link.startsWith("www.facebook") || link.startsWith("www.twitter") || link.startsWith("www.github"))
      link = "https://" + link;
    else if (type == 'linkedin' && !(link.includes("https://www.linkedin") || link.includes("https://linkedin") || link.includes("https://in.linkedin") || link.includes("http://linkedin") || link.includes("http://www.linkedin")))
      link = "https://www." + link;
    else if (type == 'facebook' && !(link.includes("https://www.facebook") || link.includes("https://facebook") || link.includes("https://in.facebook") || link.includes("http://facebook") || link.includes("http://www.facebook")))
      link = "https://www." + link;
    else if (type == 'twitter' && !(link.includes("https://www.twitter") || link.includes("https://twitter") || link.includes("https://in.twitter") || link.includes("http://twitter") || link.includes("http://www.twitter")))
      link = "https://www." + link;
    else if (type == 'github' && !(link.includes("https://www.github") || link.includes("https://github") || link.includes("https://in.github") || link.includes("http://github") || link.includes("http://www.github")))
      link = "https://www." + link;
    window.open(link, "_blank")
  }


  isBoolean(value: any) {
    if (typeof value == 'boolean' || value == 'true') {
      return true;
    }
    return false;
  }

  transform(value: string | string[]): string {
    if (!value) {
      return '';
    }

    if (Array.isArray(value)) {
      value = value[0] || '';
    }

    const regex = /(<.*?>)?([^<>]+)/g;
    const transformedValue = value.replace(regex, (match, htmlTag, text) => {
      if (text) {
        const transformedText = text.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
        const result = htmlTag ? `${htmlTag}${transformedText}` : transformedText;
        // remove htmltag
        if (result.includes('<')) {
          return result.replace(/<.*?>/g, '');
        }

        return result;
      }
      return match;
    });
    return transformedValue;
  }

  setPage(index: number){
    this.start = (index - 1) * this.pageSize;
    this.end = this.start + this.pageSize;
    this.currentPage = index;
    if(this.profileCount / this.pageSize <= index){
      this.profileCount = this.profileCount + 10;
    }
    this.getProfile();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  private getGenericDataSourceYOE() {
    return {
      type: "column2d",
      dataFormat: "json",
      height: "200",
      width: "200",
      chart: {
        paletteColors: "#b4d0fd;",
        captionFontColor: "#F4AB33",
        showPercentValues: "1",
        yAxisNameFontColor: "#F4AB33",
        legendAllowDrag: "1",
        theme: "fusion",
        valuePosition: "right",
        showYAxisValues: "1",
      },
      data: [],
    }
  }

  private handleYOEUpdateEvent(typeData: {
    yoeType: string;
    emmitedFrom: string;
  }) {
    if (typeData.emmitedFrom === GeneralConstants.COMPONENT_NAME.REPORT_PROFILES)
        return;
    this.setYOEType(typeData.yoeType);
    this.filterDataHandlerService.setYOEType(typeData.yoeType);
    this.getYearsOfExperience();
  } 

  private setYOEType(yoeType) {
    console.log('set yoe type called ', yoeType);
    if (yoeType === GeneralConstants.YOE_TYPE.AVG) {
      this.experienceType = 'averageyearsofexperience';
      this.selectedExperience = GeneralConstants.YOE_TYPE.AVG;
    }
    else if (yoeType === GeneralConstants.YOE_TYPE.TOTAL) {
      this.experienceType = 'totalyearsofexperience';
      this.selectedExperience = 'Overall';
    }
  }

  /**
   * Share data with parent to initiate insights-export
   * @param requestData 
   */
  shareDataForInsightsExport(requestData: { type?: string, action?: string, data?: { currentTab?: string } }) {
    if(requestData?.data?.currentTab !== 'profiles') return;

    // YOE chart config
    const yoeChart = { renderAt: 'yoeChart', dataSource: { ...this.dataSourceYearsOfExperience } };
    yoeChart['type'] = yoeChart['dataSource']['type'];
    delete yoeChart['dataSource']['type'];
    delete yoeChart['dataSource']['width'];
    delete yoeChart['dataSource']['chart']['width'];
    delete yoeChart['dataSource']['height'];
    delete yoeChart['dataSource']['chart']['height'];
    yoeChart['dataSource']['chart']['legendPosition'] = 'bottom';
    
    // YOE chart config
    const yoeChartCurrent = { renderAt: 'yoeChartCurrent', dataSource: { ...this.dataSourceYearsOfExperienceCurrent } };
    yoeChartCurrent['type'] = yoeChartCurrent['dataSource']['type'];
    delete yoeChartCurrent['dataSource']['type'];
    delete yoeChartCurrent['dataSource']['width'];
    delete yoeChartCurrent['dataSource']['chart']['width'];
    delete yoeChartCurrent['dataSource']['height'];
    delete yoeChartCurrent['dataSource']['chart']['height'];
    yoeChartCurrent['dataSource']['chart']['legendPosition'] = 'bottom';

    // seniority chart config
    const seniorityChart = { renderAt: 'seniorityChart', dataSource: { ...this.seniorityData } };
    seniorityChart['type'] = seniorityChart['dataSource']['type'];
    delete seniorityChart['dataSource']['type'];
    delete seniorityChart['dataSource']['width'];
    delete seniorityChart['dataSource']['chart']['width'];
    delete seniorityChart['dataSource']['height'];
    delete seniorityChart['dataSource']['chart']['height'];
    seniorityChart['dataSource']['chart']['legendPosition'] = 'bottom';

    const payloadForInsightsExport = {
      tab: 'profiles',
      totalresultcount: this.totalResultsCount,
      chartdetails: [yoeChart, yoeChartCurrent, seniorityChart],
      profiles: this.profileDataAll,
      selectedExperience: this.selectedExperience
    }
    this.talentInsightsService.sendInsightsExportData(payloadForInsightsExport);
  }

  getprofiledataai(data, type) {
    if(type == 'yearsofexp') {
      this.yearsofexpdata = data.map(x=>{
        let res: any ={};
        res['Years'] = x.key;
        res['Talent Count'] = x.doc_count;
        return res;
      
      })
    } 
    if(type == 'seniority') {
      this.senioritydata = data.map(x=>{
        let res: any ={};
        res['Seniority'] = x.key;
        res['Talent Count'] = x.doc_count;
        return res;
      
      })
    }

    this.profiledataai = {
      yearsofexperience: this.yearsofexpdata,
      seniority: this.senioritydata
    }
    if(this.yearsofexpdata.length == 0 && this.senioritydata.length == 0)
      this.profiledataai = null;
  }
}
